import { Checkbox, Group, Stack, useMantineTheme } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { Text } from '~/domains/design-system/Text';
import { TextInput } from '~/domains/design-system/TextInput';
import IconShield from '~/domains/design-system/icons/IconShield';
import { ButtonLink } from '~/domains/design-system/Button';

import dt from '../../../testing.const';

import useStyles from './EnterContestScreen.styles';

type EntryZipVerificationCardProps = {
  zipCode: string;
  isZipTermsChecked: boolean;
  zipCodeError?: string;
  maxZipLength: number;
  termsUrl: string;
  onZipCodeChange: (value: string) => void;
  onZipTermsChange: (value: boolean) => void;
};

function EntryZipVerificationCard({
  zipCode,
  isZipTermsChecked,
  zipCodeError,
  maxZipLength,
  termsUrl,
  onZipCodeChange,
  onZipTermsChange,
}: EntryZipVerificationCardProps) {
  const { t } = useTranslation('contest');
  const theme = useMantineTheme();
  const { classes } = useStyles();

  return (
    <Stack spacing={theme.other.spacing._16} className={classes.zipGateSection}>
      <div className={classes.verificationCard}>
        <Stack spacing={theme.other.spacing._4} align="center">
          <IconShield size={32} color={theme.colors.blue[7]} />
          <Text variant="subhead-large" color={theme.colors.gray2[7]} ta="center">
            {t('common.enterContestModal.enterContest.verificationRequiredTitle')}
          </Text>
          <Text variant="subhead-small" color={theme.colors.gray2[3]} ta="center">
            {t('common.enterContestModal.enterContest.verificationRequiredSubtitle')}
          </Text>
        </Stack>

        <TextInput
          value={zipCode}
          onChange={(event) => onZipCodeChange(event.currentTarget.value)}
          placeholder={t('common.enterContestModal.enterContest.zipCodePlaceholder')}
          maxLength={maxZipLength}
          error={zipCodeError}
          variant="filled"
          className={classes.zipInput}
          data-test-id={dt.enterContestModal.action.zipCode}
        />
        <Checkbox
          checked={isZipTermsChecked}
          onChange={(event) => onZipTermsChange(event.currentTarget.checked)}
          data-test-id={dt.enterContestModal.action.zipTermsCheckbox}
          classNames={{ label: classes.zipTermsLabel }}
          label={
            <Group spacing={theme.other.spacing._4} align="center">
              <Text variant="subhead-small" color={theme.colors.gray2[3]}>
                {t('common.enterContestModal.enterContest.zipTermsPrefix')}
              </Text>
              <ButtonLink
                href={termsUrl}
                target="_blank"
                rel="noopener noreferrer"
                variant="primary-text"
                size="small"
                className={classes.zipTermsLink}
              >
                {t('common.enterContestModal.enterContest.zipTermsLink')}
              </ButtonLink>
            </Group>
          }
        />
      </div>
    </Stack>
  );
}

export default EntryZipVerificationCard;
